import { baseUrl } from "../constants";
import apiFunctions from "./axiosConfig/apiFunctions";
import CustomToast from "../components/Toast";
const BASE_URL = `${process.env.REACT_APP_ADMIN_API_URL}/api/v2/org/`;
 
export const fetchMicroCourseData = async (searchtext) => {
  try {
    searchtext = searchtext?.length > 1 ? searchtext : '';
    const responseGet = await apiFunctions.fetchData(`${baseUrl}getMicroCourseList?pageNumber=1&limit=100&search=${searchtext}`);
    return responseGet;
  } catch (error) {
    CustomToast.error('Error while fetcing course data')
    return error;
  }
};
 
export const saveMicroCourseWithLang = async (postData) => {
  try {
    // POST request
    const responseGet = await apiFunctions.postData(`${baseUrl}createMultiCourse`, postData);
    sessionStorage.setItem("courseId", responseGet.data?.courses[0]?.course_meta_id)
    console.log("Response Data:", responseGet.data);
    CustomToast.success('Course data saved successfully')
    return responseGet;
  } catch (error) {
    CustomToast.error('Error while save course data')
    return error;
  }
};
 
export const saveCourseWithAnotherLang = async (postData) => {
  try {
    // POST request
    const responseGet = await apiFunctions.postData(`${baseUrl}createCourseLanguage`, postData);
    sessionStorage.setItem("courseId", responseGet.data?.courses[0]?.course_meta_id)
    CustomToast.success('Course created successfully')
    return responseGet;
  } catch (error) {
    CustomToast.error('Error while save course data')
    return error;
  }
};
 
export const saveDuplicateCourse = async (postData) => {
  try {
    // POST request
    const responseGet = await apiFunctions.postData(`${baseUrl}createDuplicateCourse`, postData);
    sessionStorage.setItem("courseId", responseGet.data?.courses[0]?.course_meta_id)
    CustomToast.success('Course created successfully')
    return responseGet;
  } catch (error) {
    CustomToast.error('Error while save course data')
    return error;
  }
};
 
export const fetchCourseDetail = async (id) => {
  try {
    // GET request
    const responseGet = await apiFunctions.fetchData(`${baseUrl}getCourseDetail/${id}`);
    sessionStorage.setItem("courseDetail", JSON.stringify(responseGet.data))
    return responseGet;
  } catch (error) {
    CustomToast.error('Error while fetcing course data')
    return error;
  }
};
 
export const updateCourseDetail = async (type, id, putData) => {
  try {
    // PUT request
    const responseGet = await apiFunctions.putData(`${baseUrl}updateCourse/${id}`, putData);
    sessionStorage.setItem("courseDetail", JSON.stringify(responseGet.data));
    if (responseGet.data.is_published == false && type == "Draft") {
      CustomToast.success('Course draft successfully')
    } else if (responseGet.data.is_published == true && type == "Publish") {
      CustomToast.success('Course published successfully')
    } else {
      CustomToast.success('Data save successfully')
    }
    return responseGet;
  } catch (error) {
    CustomToast.error('Error occurred while publishing the course')
    return error;
  }
};
 
export const createMicroCourse = async (microCourseData) => {
  try {
    const responsePost = await apiFunctions.postData(`${baseUrl}createMultiCourse`, microCourseData);
    sessionStorage.setItem("courseId",responsePost.data?.courses[0]?.course_meta_id)
 
    CustomToast.success('Course created successfully')
    return responsePost;
  } catch (error) {
    CustomToast.error('Error while creating micro course');
    return error;
  }
};
 
export const sendMicroCourseReminder = async (courseId) => {
  try {
    const postData = {
      course_id: courseId
    };
    const token = localStorage.getItem('authToken');
    const responsePost = await apiFunctions.postData(
      `${BASE_URL}send-micro-course-reminder`,
      postData, // Body data
      {
        headers: {
          token: token,
          'Content-Type': 'application/json',
          'app-key': process.env.REACT_APP_API_KEY,
        },
      }
    );
    CustomToast.success('Notification sent successfully');
    return responsePost;
  } catch (error) {
    CustomToast.error('Error while sending notification');
    return error;
  }
};